import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import * as Icons from 'lucide-react';
import axios from 'axios';
import { OCCASIONS, BRANDS } from '../mock/mock';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const OccasionGrid = () => (
  <section className="py-16 md:py-20 bg-white">
    <div className="max-w-7xl mx-auto px-4">
      <div className="text-center max-w-2xl mx-auto mb-10">
        <h2 className="font-serif-display text-3xl md:text-4xl text-[#2C2416]">Corporate gifting for every occasion</h2>
        <p className="text-[#5B4A3A] mt-3">Pick the moment. We will design the gift.</p>
      </div>
      <div className="grid grid-cols-3 sm:grid-cols-4 lg:grid-cols-6 gap-3 md:gap-4">
        {OCCASIONS.map((o) => {
          const Icon = Icons[o.icon] || Icons.Gift;
          return (
            <Link key={o.slug} to={`/category/corporate/${o.slug}`}
              className="group rounded-2xl bg-[#FAF6F1] hover:bg-[#F4D5C5] border border-transparent hover:border-[#F4D5C5] transition-colors p-5 text-center">
              <div className="w-12 h-12 mx-auto rounded-full bg-white flex items-center justify-center mb-3 shadow-sm group-hover:scale-105 transition-transform">
                <Icon className="w-5 h-5 text-[#C58B76]" />
              </div>
              <div className="text-xs md:text-sm font-medium text-[#2C2416] leading-tight">{o.name}</div>
            </Link>
          );
        })}
      </div>
    </div>
  </section>
);

export const BrandsTicker = () => {
  const [logos, setLogos] = useState([]);

  useEffect(() => {
    axios.get(`${API}/logos`).then(r => setLogos(r.data || [])).catch(() => setLogos([]));
  }, []);

  const hasLogos = logos.length > 0;
  const items = hasLogos ? [...logos, ...logos] : [...BRANDS, ...BRANDS];

  return (
    <section className="py-14 md:py-16 bg-[#F4E7DA]">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-8">
          <h3 className="font-serif-display text-2xl md:text-3xl text-[#2C2416]">Powering Corporate Gifting for Global Brands</h3>
          <p className="text-sm text-[#7A5C4C] mt-1">Clients across the globe</p>
        </div>
        <div className="overflow-hidden relative">
          <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#F4E7DA] to-transparent z-10" />
          <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#F4E7DA] to-transparent z-10" />
          <div className="flex gap-10 animate-marquee w-max">
            {items.map((b, i) => (
              <div key={i} className="flex items-center justify-center h-16 min-w-[160px] bg-white rounded-lg px-6 shadow-sm">
                {hasLogos ? (
                  <img
                    src={`${process.env.REACT_APP_BACKEND_URL}${b.url}`}
                    alt={b.name}
                    title={b.name}
                    className="max-h-10 max-w-[140px] object-contain grayscale hover:grayscale-0 transition-all"
                  />
                ) : (
                  <span className="font-serif-display text-xl text-[#2C2416] whitespace-nowrap">{b}</span>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export const InfoTicker = () => {
  const items = ['PAN India Delivery', '4k+ Gifting Options', '2k+ Brand Partners', 'GST Billing', 'Custom Branding', 'Dedicated Manager'];
  return (
    <div className="bg-[#2C2416] text-[#F4D5C5] py-3 overflow-hidden">
      <div className="flex gap-14 animate-marquee-slow w-max">
        {[...items, ...items, ...items].map((t, i) => (
          <span key={i} className="text-xs uppercase tracking-[0.3em] flex items-center gap-14 whitespace-nowrap">
            {t} <span className="text-[#C58B76]">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};
